<template>
  <div class="c-inherit-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum">
      <div class="divider-view-top top-spacing" />
      <div class="column full-width homepage-container">
        <div class="header">
          <div>
            <h4
              style="font-size: 17px;"
              class="text-left text-center c-bold-text"
            >
              {{ $t("bookingSwitchboard") }}
            </h4>
          </div>
          <div>
            <BookingFast />
          </div>
        </div>
      </div>
    </div>
    <div
      style="padding-top: 0 !important; padding-bottom: 0 !important"
      class="container column"
      v-for="(item, index) in list_category_tee"
      :key="index"
    >
      <CarouselFacility
        :is-flash-sale="item.is_flash_sale"
        :end-date-sale="item.end_date_timestamp"
        :start-date-sale="item.start_date_timestamp"
        :list-data="item.products"
        :title="item.name"
        :object-data="item"
      />
    </div>
    <!-- <div style="padding: 0 !important" class="container column mt-10 mb-20">
      <BannerHome />
    </div> -->
    <div
      style="padding-top: 0 !important; padding-bottom: 0 !important"
      class="container column"
    >
      <CarouselReviewFacility :title="$t('wap.text147')" />
    </div>
    <div
      style="padding-top: 0 !important; padding-bottom: 0 !important"
      class="container column"
    >
      <News :title="$t('wap.text148')" />
    </div>
    <popupBanner
      v-if="isShowPopup"
      :isShowPopup="isShowPopup"
      :objectData="urlImage"
      @close="handleClosePopup"
    />
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import HomeRequest from "@/views/api/wapV2/homepage.js";
import CarouselFacility from "./facility/CarouselFacility";
import CarouselReviewFacility from "./facility/CarouselFacility/Review.vue";
import News from "./news";
import BannerHome from "@/components/banner/Home.vue";
import {
  getToken,
  setToken,
  getBackGround,
  setCookie,
  getCookie,
  posterModalId,
  setFlag,
  setLanguage,
  sourceBuyWap,
  eventSendInfoUserGa
} from "@/utils/wapAuth";
import { detail } from "@/views/api/user";
import jwt from "jsonwebtoken";
import BookingFast from "@/views/pages/wapV2/booking";
import { getDetailUser } from "@/views/api/wapV2/user";
import { formatDate } from "@/utils/formatData";
import popupBanner from "@/components/popup/popupBanner.vue";
import i18n from "@/plugins/i18n";
import HomepageResource from "../../api/wapV2/homepage";
import getPageTitle from "@/utils/get-page-title";
import { mapGetters, mapActions } from "vuex";
import TeeTimeResource from "@/views/api/wapV2/tee-time.js";
import {
  SOURCE_BANK,
  list_path_by_source,
  list_screen,
  REVERSED_SOURCE_BANK
} from "@/constant/contant";
import { sendEvenGA, titleWeb } from "@/utils/ga";
import { setLocaleByLang } from "../../../utils/wapAuth";

export default {
  components: {
    MainNavBarWapV2,
    BookingFast,
    popupBanner,
    CarouselFacility,
    CarouselReviewFacility,
    News
    // BannerHome
  },
  bodyClass: "home-page",
  props: {},
  created() {
    const curPath = this.$route.path;
    // this.openFullScreen2();
    this.setTitlePageBypath(curPath);

    // route
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let route_token = params.get("token");

    setLocaleByLang(params.get("language"));

    // header
    // const req = new XMLHttpRequest();
    // req.open("GET", document.location, false);
    // req.send(null);
    let token = route_token;
    token = token ? token.replace("?token=null", "") : null;
    const newToken = token || route_token;

    if (newToken && newToken !== getToken().token) {
      const jToken = jwt.decode(token);
      if (jToken) {
        const source = REVERSED_SOURCE_BANK[jToken.bank_id];
        getPageTitle(source);
        setCookie(eventSendInfoUserGa, "1", { expires: 1 / 24 });
        this.getEventInfoUser(`user_source_${source}`, {
          source,
          phone: jToken.phone,
          uid: jToken.vga,
          fullname: jToken.fullname
        });
      }
      detail(token).then(async res => {
        if (res.error_code != 0) {
          this.$message.warning(res.error_msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
          return;
        }
        let user = {
          token,
          fullname: res.data?.fullname,
          vga: res.data?.vga,
          id_display: res.data?.id_display,
          merchant: res.data?.merchant,
          bank_id: jToken?.bank_id || null,
          order_id: jToken?.orderId || null
        };
        const info = await this.refDetailUser(user.vga);
        user = {
          ...user,
          ...info
        };
        const lang = jToken.lag || "vn";
        this.handleLang(lang);
        setToken(user);
        if (jToken.bank_id == SOURCE_BANK.BIDV) {
          window.location.reload();
        } else {
          this.$store.dispatch("reRenderComponent");
          this.getPopupHome();
          this.getBannerHome();
        }
      });
    } else {
      this.getBannerHome();
      this.checkSourceByRoute(curPath);
      //this.getPopupHome();
      this.getEventInfoOutAndWap(curPath);
      this.onGetListTeetime();
    }
  },
  data() {
    return {
      isShowPopup: false,
      isLoadingPage: true,
      isActive: 0,
      isLoading: false,
      infoHeader: {
        title: this.$t("bookField"),
        isShowHomeIcon: true
      },
      bg: getBackGround(),
      urlImage: {}
    };
  },
  computed: {
    ...mapGetters(["info_banner", "list_teetime", "list_category_tee"])
  },
  mounted() {},
  watch: {},
  methods: {
    getToken,
    formatDate,
    ...mapActions([
      "update_info_banner",
      "update_teetime",
      "set_data_category_tee"
    ]),
    getEventInfoOutAndWap(path) {
      if (getCookie(eventSendInfoUserGa)) return;
      const listPath = list_path_by_source;
      const pathCur = path;
      const sourceInfo = listPath.find(i => i.path == pathCur);
      const uInfo = getToken();
      let source = "WAP";

      if (sourceInfo) {
        source = sourceInfo.name;
      }
      if (!uInfo.token) {
        this.getEventInfoUser(`user_source_${source}`, { source });
        setCookie(eventSendInfoUserGa, "1", { expires: 1 / 24 });
        return;
      }
      if (uInfo.token) {
        const body = {
          uid: uInfo.vga,
          phone: uInfo.phone,
          fullname: uInfo.fullname || uInfo.phone,
          source
        };
        if (!uInfo.bank_id) {
          source = "WAP";
          this.getEventInfoUser(`user_source_${source}`, body);
          setCookie(eventSendInfoUserGa, "1", { expires: 1 / 24 });
        } else if (listPath.some(i => i.source_id == uInfo.bank_id)) {
          source = REVERSED_SOURCE_BANK[uInfo.bank_id];
          this.getEventInfoUser(`user_source_${source}`, body);
          setCookie(eventSendInfoUserGa, "1", { expires: 1 / 24 });
        }
      }
    },
    getEventInfoUser(eventName, body) {
      let noLogin = "Ngoài hệ thống";
      const dataGtag = {
        uid: body.uid || "-1",
        user_vid: body.uid || "-1",
        phone: body.phone || noLogin,
        source: body.source || "WAP",
        fullname: body.fullname || noLogin
      };
      sendEvenGA(eventName, dataGtag);
    },
    setTitlePageBypath(path) {
      if (path == "/bussiness") {
        getPageTitle("Trang chủ");
      }
    },
    handleRedirectLink() {
      if (this.info_banner && this.info_banner.link_redirect) {
        window.open(this.info_banner.link_redirect);
      }
    },
    handleClosePopup() {
      this.isShowPopup = false;
    },
    async getBannerHome() {
      if (this.info_banner) return;
      let screen_type = 6;
      if (getToken().bank_id) {
        screen_type =
          list_screen.find(i => i.mapBankId == getToken().bank_id)?.key || 6;
      }
      const res = await HomepageResource.getBannerHomePage({
        uid: getToken().uid || "105581",
        screen_type,
        position: 2,
        is_wap: 1
      });
      if (res.error_code != 0) return;
      if (!res.data) return;
      const images = res.data;
      if (images && images.length > 0) {
        const imgRandom = images[Math.floor(Math.random() * images.length)];
        this.update_info_banner({
          url: imgRandom.banner_url,
          link_redirect: imgRandom.url
        });
      }
    },
    async getPopupHome() {
      if (getCookie(posterModalId)) return;
      let screen_type = 6;
      if (getToken().bank_id) {
        screen_type =
          list_screen.find(i => i.mapBankId == getToken().bank_id)?.key || 6;
      }
      const res = await HomepageResource.getBannerHomePage({
        uid: getToken().uid || "105581",
        screen_type,
        position: 1,
        is_wap: 1
      });
      if (res.error_code != 0) return;
      if (!res.data) return;
      const images = res.data;
      if (images && images.length > 0) {
        const imgRandom = images[Math.floor(Math.random() * images.length)];
        this.urlImage = {
          url: imgRandom.banner_url,
          link_redirect: imgRandom.url
        };
        setCookie(posterModalId, "1", { expires: 5 / 1440 });
        setTimeout(() => {
          this.isShowPopup = true;
        }, 2000);
      }
    },
    async onGetListTeetime() {
      if (this.list_category_tee.length > 0) {
        return;
      }
      this.isLoading = true;
      const { error_code, data } = await TeeTimeResource.getListCategoryPax();
      if (error_code != 0) {
        this.isLoading = false;
        return;
      }

      const ids = [
        ...new Set(data.flatMap(item => item.products?.map(i => i.facility_id)))
      ];

      const images = await this.getListImageFacility(ids);
      let mapData = [];
      if (images) {
        mapData = data
          .map(obj1 => {
            const products = obj1.products.map(i => {
              const match = images.find(obj2 => obj2.id === i.facility_id);
              if (match) {
                return { ...i, images: match.images[0] };
              }
            });
            return { ...obj1, products };
          })
          .reverse();
      }
      console.log("mapData+++++++++++++++++", mapData);
      this.set_data_category_tee(mapData);
      this.isLoading = false;
    },
    async getListImageFacility(ids) {
      try {
        const { error_code, data } = await HomeRequest.getImageFacility({
          ids
        });
        if (error_code === 0) {
          return data.map(i => ({ id: i.course_id, images: i.images }));
        }
        return null;
      } catch (error) {
        this.isLoading = false;
      }
    },
    sendEventPageViewGA(page_title) {
      const data = {
        page_title,
        page_location: window.location.href
      };
      sendEvenGA("page_view", data);
    },
    checkSourceByRoute(path) {
      const listPath = list_path_by_source;
      const pathCur = path;
      const sourceInfo = listPath.find(i => i.path == pathCur);
      const bank_id = getToken().bank_id;
      if (sourceInfo) {
        console.log("sourceInfo_________", sourceInfo);
        setCookie(sourceBuyWap, sourceInfo.source_id);
        this.sendEventPageViewGA(`${sourceInfo.name} - ${titleWeb}`);
        return;
      } else if (bank_id && listPath.some(i => i.source_id == bank_id)) {
        this.sendEventPageViewGA(
          `${REVERSED_SOURCE_BANK[bank_id]} - ${titleWeb}`
        );
        return;
      } else if (!bank_id && !getCookie(sourceBuyWap)) {
        this.sendEventPageViewGA(`WAP - ${titleWeb}`);
      }
    },
    async refDetailUser(uid) {
      let user = {};
      const info = await getDetailUser({ uid });
      if (info.error_code === 0) {
        user = {
          avatar: info.data.avatar,
          type_member: info.data.type_member,
          point_wallet: info.data.point_wallet
        };
        // this.$store.dispatch("reRenderComponent");
      }
      return user;
    },
    openFullScreen2() {
      this.isLoadingPage = true;
      setTimeout(() => {
        this.isLoadingPage = false;
      }, 2000);
    },
    handleLang(lang) {
      let lag = "vi";
      switch (lang) {
        case "en":
          setFlag("us");
          lag = "en";
          break;
        case "vn":
          setFlag("vn");
          lag = "vi";
          break;
        default:
          break;
      }
      setLanguage(lag);
      i18n.locale = lag;
    }
  }
};
</script>
<style>
.slick-slide {
  padding-right: 10px;
  padding-left: 10px;
}
</style>

<style scoped>
.top-spacing {
  padding-top: 80px;
}
.dialog .el-dialog {
  border-radius: 20px;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}

.text-time {
  margin: 0;
  color: black;
  font-weight: 500;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mb-10 {
  margin-bottom: 10px;
}

.ml-10 {
  margin-left: 10px;
}

.flex-grow {
  flex-grow: 1;
}
.header-banner {
  padding-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }

  .top-spacing {
    padding-top: 40px !important;
  }
  .search-bar-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .mt-8 {
    margin-top: 8px;
  }
}
</style>

<style lang="scss">
@font-face {
  font-family: "SF Pro Display";
  src: url("/assets/fonts/SF-Pro-Display/SF-Pro-Display-Regular.otf")
    format("opentype");
  font-weight: normal;
  font-style: normal;
}
$divider-color: #d9d9d9;
.homepage-container {
  .divider-view {
    height: 15px;
    width: 100%;
    background-color: $divider-color;
  }
  .divider-view-top {
    height: 15px;
    width: 100%;
  }
  .column {
    flex-direction: column;
  }
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .full-width {
    width: 100%;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    .title-h3 {
      font-size: 14px !important;
    }

    .text-time {
      font-size: 13px;
    }
  }

  @media screen and (min-width: 0px) and (max-width: 991px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
}
</style>
